import request from "@/common/js/request.js";
import requestToGetFile from "@/common/js/requestToGetFile.js";

// fetchCourseType
export function fetchCourseType() {
  const url = "/courseType/getCourseTypeListForMobile";
  const data = Object.assign(
    {},
    {
      pageNo: "1",
      pageSize: "50"
    }
  );
  return request({
    url: url,
    method: "get",
    params: data
  });
}

/* 移动端查询推荐课程
   pageSize
   pageNo
*/
export function fetchReCommendCourse(obj) {
  return request({
    url: "/course/listRecommendCourseForMobile",
    method: "get",
    params: obj
  });
}

export function getOrganAboutCourse(obj) {
  return request({
    url: "/course/getCourseListByCondition",
    method: "get",
    params: obj
  });
}

export function getCoursePid(id) {
  return request({
    url: "/courseType/queryCourseTypeById/" + id,
    method: "get"
  });
}

export function getCourse(obj) {
  return request({
    url: "/course/getCourseListByCondition",
    method: "get",
    params: obj
  });
}

export function getCourseEvaluate(obj) {
  return request({
    url: "/courseComment/getCourseCommentListByCondition",
    method: "get",
    params: obj
  });
}

// 添加评论
export function addCourseEvaluate(obj) {
  return request({
    url: "/courseComment/addCourseComment",
    method: "post",
    params: obj
  });
}
//*查询章节列表
export function getCourseChapter(obj) {
  return request({
    // url: '/courseDetail/page',
    url: "/courseChapter/getCourseChapterListForMobile",
    method: "get",
    params: obj
  });
}

// 获取课程章节列表
export function getCourseChapterlist(obj) {
  return request({
    url: "/coursePartDetail/getCourseDetailListByCondition",
    method: "get",
    params: obj
  });
}

// 获取播放视频的STS
export function getSTSVideo() {
  return request({
    url: "/coursePartDetail/getSTSVideo",
    method: "get"
  });
}

// 获取小节信息
export function getSectionMsg(obj) {
  // let obj = {
  //   coursePartDetailId: id
  // }
  return request({
    url: "/coursePartDetail/selectOneById",
    method: "get",
    params: obj
  });
}

//*查询课程老师
export function getCourseteacher(obj) {
  return request({
    url: "/courseTeacher/selectCourseTeachers",
    method: "get",
    params: obj
  });
}

// 获取pdf文件流
export function getFileStream(CoursePartDetailId) {
  let obj = {
    CoursePartDetailId
  };
  return request({
    url: "/coursePartDetail/getFileStreamByCoursePartDetailId",
    method: "get",
    params: obj
    // responseType: 'blob',
  });
}

export function getcourseIntro(obj) {
  return request({
    url: "/course/getCourseByCourseId",
    method: "get",
    params: obj
  });
}

//加入学习
export function fetchcourseStudy(obj) {
  return request({
    url: "/courseStudy/addCourseStudy",
    method: "post",
    params: obj
  });
}
//我的课程
export function fetchcourseStudylist(obj) {
  return request({
    url: "/courseStudy/getCourseStudyList",
    method: "get",
    params: obj
  });
}
//我的收藏的课程
export function fetchCollectionCourseStudylist(obj) {
  return request({
    url: "/courseFavorite/getCourseFavotiteList",
    method: "get",
    params: obj
  });
}

//查询是否购买
export function fetchCourseState(query) {
  return request({
    url: "/course/getCourseStateWithUserId",
    method: "get",
    params: query
  });
}

//查询是否收藏
export function fetchcheckCourse(obj) {
  return request({
    url: "/courseFavorite/checkCourseFavoriteRecord",
    method: "get",
    params: obj
  });
}

//添加收藏
export function fetchaddCourse(obj) {
  return request({
    url: "/courseFavorite/addCourseFavoriteRecord",
    method: "post",
    params: obj
  });
}

//取消收藏
export function fetchdelCourse(obj) {
  return request({
    url: "/courseFavorite/delCourseFavoriteRecord",
    method: "delete",
    params: obj
  });
}

//查询
export function fetchsearchCourse(obj) {
  return request({
    url: "/search/courseByName",
    method: "get",
    params: obj
  });
}

// 课程小节学习服务
export function fetchUpdateStudyProgress(obj) {
  return request({
    url: "/coursePartStudy/updateStudyProgress",
    method: "put",
    data: obj
  });
}

// 通过ossUrl 获取播放地址
export function fetchPlayUrl(ossUrl) {
  let obj = {
    ossUrl
  };
  return request({
    url: "/coursePartDetail/aliyun/getOSSVideoUrl",
    method: "get",
    params: obj
  });
}

// 查询课程分类接口
export function fetchcorusecalss(obj) {
  return request({
    url: "/course/searchCourseList",
    method: "post",
    data: obj
  });
}
// 查询数据字典接口
export function fetchcorusezd(obj) {
  return request({
    url: "/dict/selectDict",
    method: "get",
    params: obj
  });
}

// 查询课程学习进度
export function fetchcourseProgress(obj) {
  return request({
    url: "/courseStudy/selectStudyProgress",
    method: "get",
    params: obj
  });
}
// 查自定义菜单- 获取所有
export function getmenus(obj) {
  return request({
    url: "/courseMenu/menus",
    method: "get",
    params: obj
  });
}
// 自定义菜单列表。新版本 ，领导要求把getmenus变成以下3个接口
export function getmenusList(obj) {
  return request({
    url: "/courseMenu/list",
    method: "get",
    params: obj
  });
}
// 自定义菜单列表——子目录列表
export function getmenusList_chapter(obj) {
  return request({
    url: "/menuChapterAndPartTreeWithOutContent/byMenuId",
    method: "get",
    params: obj
  });
}
// 自定义菜单列表——子目录列表-详情
export function getCourseMenuPart_info(obj) {
  return request({
    url: "/select/courseMenuPart/info",
    method: "get",
    params: obj
  });
}

//查询老师id
export function getTeacherUid(obj) {
  return request({
    url: "/coursePartDetail/getTeacherUid",
    method: "get",
    params: obj
  });
}

//清空学习进度
export function cleanStudy(obj) {
  return request({
    url: "/courseStudy/clean/courseProgress",
    method: "post",
    params: obj
  });
}

// 课程章节，资源，自定义目录-文件转换成功-图片列表
export function getFilePartsList(obj) {
  return request({
    url: "/org/resource/file/parts",
    method: "get",
    params: obj
  });
}

// 获取课程章节-资源详情
export function coursePartDetailInfo(obj) {
  return request({
    url: "/coursePartDetail/partResource/info",
    method: "get",
    params: obj
  });
}



// WEBPACK FOOTER //
// ./src/api/course.js